<template>
    <nav class="application-nav">
        <v-app-bar dark color="primary">
            <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
            <v-btn text :to="{ name: 'dashboard' }"><v-icon left>home</v-icon><span class="d-none d-sm-flex">DASHBOARD</span></v-btn>
            <v-spacer></v-spacer>
            <v-btn class="mr-4 text-center" fab dark small color="indigo" @click.native="toggleShowCart">
                <v-badge :content="shoppingCartCount" :value="shoppingCartCount" color="secondary" offset-x="45" overlap>
                    <v-icon>shopping_cart</v-icon>
                </v-badge>
            </v-btn>
            <v-toolbar-title class="white--text">{{ user.firstname }}</v-toolbar-title>
            <v-btn text @click="logout"><v-icon left>power_settings_new</v-icon><span class="d-none d-sm-flex">LOGOUT</span></v-btn>
        </v-app-bar>

        <v-navigation-drawer temporary absolute dark class="blue lighten-3" v-model="drawer">
            <v-list dense dark class="blue lighten-3">
                <v-list-item>
                    <v-list-item-title class="title">
                        {{ appNameUrls.client }}
                    </v-list-item-title>
                </v-list-item>
            </v-list>

            <v-divider></v-divider>

            <v-list dense class="pt-0">
                <v-list-item :to="{ name: 'dashboard' }">
                    <v-list-item-action>
                        <i class="icx-menu fas fa-home"></i>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Dashboard</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item :to="{ name: 'profile' }">
                    <v-list-item-action>
                        <i class="icx-menu fas fa-address-card"></i>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Profile</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item :to="{ name: 'eft' }" v-if="user.is_eft">
                    <v-list-item-action>
                        <i class="icx-menu fas fa-piggy-bank"></i>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>EFT Details</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item :to="{ name: 'membership', query: { sport: this.sport.text.toLowerCase().trim().replace('register for ','') } }" v-if="hasTeam">
                    <v-list-item-action>
                        <i class="icx-menu fas fa-basketball-ball"></i>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Registration</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item :to="{ name: 'invoicesList' }">
                    <v-list-item-action>
                        <i class="icx-menu fas fa-calculator"></i>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Invoices</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item :to="{ name: 'teamsList' }" v-if="hasTeam">
                    <v-list-item-action>
                        <i class="icx-menu fas fa-users"></i>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Teams</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item :to="{ name: 'ordersList' }">
                    <v-list-item-action>
                        <i class="icx-menu fas fa-file-invoice-dollar"></i>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Receipts</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item :to="{ name: 'teamNomination' }" v-if="isAdult">
                    <v-list-item-action>
                        <i class="icx-menu fas fa-users-cog"></i>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Team Nomination</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item :to="{ name: 'referee' }" v-if="user.is_ref">
                    <v-list-item-action>
                        <i class="icx-menu fas fa-user-ninja"></i>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Competition Roster</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item :to="{ name: 'refereeavail' }" v-if="user.is_ref">
                    <v-list-item-action>
                        <i class="icx-menu fas fa-calendar-check"></i>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Competition Availability</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item :to="{ name: 'roster' }" v-if="user.is_roster">
                    <v-list-item-action>
                        <i class="icx-menu fas fa-calendar-alt"></i>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Event Roster</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item :to="{ name: 'products' }">
                    <v-list-item-action>
                        <i class="icx-menu fas fa-shopping-cart"></i>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Store</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <!-- <v-list-item :to="{ name: 'bookings' }">
                    <v-list-item-action>
                        <i class="icx-menu fas fa-business-time"></i>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Court Hire</v-list-item-title>
                    </v-list-item-content>
                </v-list-item> -->

                <v-list-item :color="'primary theme--dark'" :to="{ name: 'hpcDashboard' }" v-if="user.is_hpc">
                    <v-list-item-action>
                        <i class="icx-menu fas fa-dumbbell"></i>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>HPC</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>

        <v-navigation-drawer v-model="showCartSideBar" right temporary absolute width="300" transition="slide-x-reverse-transition">
            <v-list-item>
                <v-list-item-avatar>
                    <v-icon>shopping_cart</v-icon>
                </v-list-item-avatar>

                <v-list-item-content>
                    <v-list-item-title
                        ><h1 class="grey--text lighten-3">
                            Shopping Cart
                        </h1></v-list-item-title
                    >
                </v-list-item-content>
            </v-list-item>

            <v-divider></v-divider>

            <v-list class="shoppingCartRight">
                <v-list-item v-for="(item, index) in shoppingCart" :key="'chk_' + index">
                    <v-list-item-content>
                        <v-list-item-title v-html="item.product_title"></v-list-item-title>
                        <v-list-item-subtitle>
                            <div class="secondary--text text--darken-4">Total: {{ item.product_totalPrice | currency }} &nbsp; - &nbsp; Quantity: {{ item.product_quantity }}
                                <v-btn class="upd_qty" small :disabled="item.product_quantity >= item.product_order_qty_max" @click.native="addProductQuantity(item)"><v-icon small color="primary">add</v-icon></v-btn>
                                <v-btn class="upd_qty" small @click.native="removeProductQuantity(item)"> <v-icon small color="primary">remove</v-icon></v-btn>
                            </div>
                            <div class="primary--text text--darken-4 mt-1" v-html="showVoucherEligibility(item.product_akv)"></div>
                            <div class="primary--text text--darken-4 mt-1" v-html="showAttendeeEligibility(item.product_no_attendee)"></div>
                        </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-btn icon ripple @click.native="removeProduct(item)">
                        <v-icon class="red--text text--lighten-1">delete</v-icon>
                    </v-btn>
                </v-list-item>
            </v-list>

            <v-simple-table class="mt-3">
                <template v-slot:default>
                    <tbody>
                        <tr>
                            <td>Subtotal ({{ shoppingCartCount | pluralize("item", { includeNumber: true }) }}):</td>
                            <td class="text-xs-right">
                                <span>{{ subTotal | currency("$") }}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>Tax:</td>
                            <td class="text-xs-right">
                                <span>{{ taxTotal | currency("$") }}</span>
                            </td>
                        </tr>
                        <tr v-if="discountTotal > 0">
                            <td>Discount:</td>
                            <td class="text-xs-right">
                                <span>{{ discountTotal | currency("$") }}</span>
                            </td>
                        </tr>
                        <tr>
                            <td><strong>Grand Total:</strong></td>
                            <td class="text-xs-right">
                                <strong
                                    ><span>{{ grandTotal | currency("$") }}</span></strong
                                >
                            </td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>

            <div class="pa-2 pb-0">
                <v-btn block color="primary" v-if="shoppingCartCount > 0" @click.native.stop="checkout">Check out</v-btn>
            </div>
            <div class="pa-2 pt-0">
                <v-btn block class="mt-2" color="secondary" @click.native.stop="shopping">Continue shopping</v-btn>
            </div>
        </v-navigation-drawer>
    </nav>
</template>

<script>
import moment from "moment";

export default {
    data() {
        return {
            links: [
                { title: "Dashboard", icon: "home", route: "dashboard" },
                { title: "Profile", icon: "account_circle", route: "profile" },
                { title: "Registration", icon: "card_membership", route: "membership" },
                { title: "Invoices", icon: "fas fa-calculator", route: "" },
                { title: "Teams", icon: "fas fa-users", route: "teamsList" },
                { title: "Receipts", icon: "fas fa-file-invoice-dollar", route: "ordersList" },
                { title: "Team Nomination", icon: "fas fa-balance-scale", route: "teamNomination" },
                { title: "Referee", icon: "fas fa-balance-scale", route: "referee" },
                { title: "Roster", icon: "fas fa-calendar-alt", route: "roster" },
                { title: "Store", icon: "fas fa-shopping-cart", route: "" },
            ],
            drawer: false,
            discountTotal: 0,
            sport: {text: 'Select Sport Profile', value: 0},
            sports: [],
            all_sports: [],
        };
    },
    computed: {
        user() {
            let sports = this.$store.getters["user/getSports"];
            if(_.size(sports)){
                this.sports = sports;
            }

            let all_sports = this.$store.getters["user/allSports"];
            if(_.size(all_sports)){
                this.all_sports = all_sports;

                if(!_.size(sports)){
                    this.sports = all_sports;
                }
            }

            return this.$store.getters["user/getProfile"];
        },
        sportsFiltered(){
            let s = _.differenceBy(this.all_sports, this.sports, 'value');

            _.forEach(this.sports, function(obj) {
                s.push(obj);
            });

            return _.sortBy(s, 'value');
        },
        isAdult() {
            return moment(this.user["dob"], "DD-MM-YYYY").isBefore(moment().subtract(18, "years"));
        },
        hasTeam() {
            return this.user["nb_teams"] > 0;
        },
        showCartSideBar: {
            get() {
                return this.$store.getters["product/showCart"];
            },
            set(v) {
                this.$store.dispatch("product/showCartState", v);
            },
        },
        shoppingCart() {
            return this.$store.getters["product/shoppingCart"];
        },
        shoppingCartCount() {
            return this.$store.getters["product/shoppingCartCount"];
        },
        shoppingCartNoAttendee() {
            return _.every(this.shoppingCart, ["product_no_attendee", true]);
        },
        subTotal() {
            let subTotal = 0;

            for (let product of this.shoppingCart) {
                subTotal += parseFloat(product.product_totalPrice);
            }

            return parseFloat(subTotal).toFixed(2);
        },
        taxTotal() {
            return this.subTotal / (taxRate + 1);
        },
        grandTotal() {
            return this.subTotal - this.discountTotal;
        },
    },
    watch: {
        sports(n, o) {
            if(n){
                this.sport = this.sportsFiltered[0];
                if(this.user.main_sport){
                    this.sport = _.find(this.sportsFiltered, ['value', this.user.main_sport]);
                }
                this.msPivotField(n[0].value);
            }
        },
    },
    methods: {
        msPivotField(sport_id, field = 'expiry_date') {
            let sportObj = _.filter(this.sportsFiltered, ['value', sport_id]);
            if(sportObj.length < 1){
                return false;
            }

            return sportObj[0][field];
        },
        toggleShowCart() {
            window.scroll(0, 0);
            this.$store.dispatch("product/showCartState", !this.showCartSideBar);
        },
        showVoucherEligibility(eligible) {
            if (eligible) {
                return 'Eligible for Active & Creative Kids <i class="fa fa-check-circle" aria-hidden="true"></i>';
            }

            return 'Not eligible for Active & Creative Kids <i class="fa fa-times-circle" aria-hidden="true"></i>';
        },
        showAttendeeEligibility(eligible) {
            if (eligible) {
                return 'No Attendee required <i class="fa fa-times-circle" aria-hidden="true"></i>';
            }

            return 'Attendee required <i class="fa fa-check-circle" aria-hidden="true"></i>';
        },
        shopping() {
            if (this.$route.name !== "products") {
                if(this.$route.name == 'hpcProducts') {
                    this.toggleShowCart();
                }else{
                    this.$router.push({ name: "products" }).catch(() => {});
                }
            } else {
                this.toggleShowCart();
            }
        },
        removeProduct(product) {
            this.$store.dispatch("product/removeProductFromCart", product);
        },
        removeProductQuantity(product) {
            this.$store.dispatch("product/removeProductQuantityToCart", product);
        },
        addProductQuantity(product) {
            this.$store.dispatch("product/addProductQuantityToCart", product);
        },
        addProduct(product) {
            this.$store.dispatch("product/addProductToCart", product);
        },
        checkout() {
            if (this.$route.name !== "checkout") {
                this.$router.push({ name: "checkout" }).catch(() => {});
            } else {
                this.toggleShowCart();
            }
        },
        logout: function() {
            this.$store
                .dispatch("auth/authLogout")
                .then(() => {
                    this.$router.push({ name: "login" });
                })
                .catch(err => {
                    this.$router.push({ name: "login" });
                });
        },
    },
};
</script>

<style lang="scss" scoped>
aside.v-navigation-drawer--right {
    width: 320px !important;
    z-index: 999999;
}

.shoppingCartRight {
    max-height: 45vh;
    overflow-y: scroll;
}

.shoppingCartRight .upd_qty {
    min-width: 25px !important;
    padding: 0 0px !important;
    height: 20px !important;
    margin-left: 5px !important;
}

@media screen and (min-width: 768px) and (max-width: 1024px) {
    .shoppingCartRight {
        max-height: 25vh;
        overflow-y: scroll;
    }
}

@media screen and (max-width: 767px) {
    .shoppingCartRight {
        max-height: 25vh;
        overflow-y: scroll;
    }
}

.application-nav {
    .icx-menu {
        font-size: 20px;
        color: #fff;
    }

    .hh-logo {
        fill: #fff;
        width: 25px;
    }

    .v-list__tile__title {
        color: #fff !important;
    }

    a.v-list__tile--link {
        &.v-list__tile--active {
            .icx-menu {
                color: var(--primary-color) !important;
            }

            .hh-logo {
                fill: var(--primary-color) !important;
            }

            .v-list__tile__title {
                color: var(--primary-color) !important;
            }
        }

        &:hover {
            .icx-menu {
                color: var(--primary-color) !important;
            }

            .hh-logo {
                fill: var(--primary-color) !important;
            }

            .v-list__tile__title {
                color: var(--primary-color) !important;
            }
        }
    }
}
</style>
